export default "__VITE_ASSET__DQ3_1v9s__"